<template>
  <v-card class="assignClient">

    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout row>
        <v-flex>
          <span class="roomName">Move Client to Room: {{ moveParams.toValues.roomName }}</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="handleCancel()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <v-layout row class="detailsRow">
        <v-flex>
          <div class="ntstValueLabel">Move Client</div>
          <div class="ntstValue">{{`${moveParams.fromValues.clientName.first} ${moveParams.fromValues.clientName.last}`}}</div>
        </v-flex>
      </v-layout>

      <v-layout row class="detailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">From Room</div>
          <div class="ntstValue">{{moveParams.fromValues.roomName}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">From Bed</div>
          <div class="ntstValue">{{moveParams.fromValues.bedName}}</div>
        </v-flex>
      </v-layout>

      <v-layout row class="detailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">To Room</div>
          <div class="ntstValue">{{moveParams.toValues.roomName}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">To Bed</div>
          <v-select style="width: 160px;" v-if="isEditable" :disabled="!isEditable" class="bedSelector ntstValue" :items="bedList(moveParams)" v-model="moveParams.toValues.bedID.id" item-value="bedBoardBedID.id" outline item-text="name"></v-select>
          <div v-if="!isEditable">{{ moveParams.toValues.bedName }}</div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="ntstAppButton" @click.stop="handleCancel()">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="handleMove()">
        Move
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
export default {
  name: 'MoveConfirmation',
  data() {
    return {
      isEditable: true
    };
  },
  components: {},

  computed: {},

  methods: {
    bedList(data) {
      let returnValue = [];

      if (data && data.toValues && data.toValues.beds) {
        returnValue = data.toValues.beds;
      }

      return returnValue;
    },

    handleCancel() {
      this.onCancel();
    },

    handleMove() {
      this.onMove(this.moveParams);
    }
  },
  props: {
    onCancel: Function,
    onMove: Function,
    moveParams: Object
  },

  created() {},

  mounted() {}
};
</script>

<style>
.bedSelector {
  width: 280px;
}
.detailsRow {
  margin-bottom: 10px;
}
</style>
